<template>
    <multiselect
        :id="id"
        :disabled="disabled"
        class="search-select"
        :value="value!==undefined ? options.find(o=>idFunc(o)===value): undefined"
        @input="v=>valueChanged(v)"
        :options="optionsSorted"
        placeholder=""
        :custom-label="labelFunc">
        <span slot="noResult" class="no_results">{{ $t('no_results') }}</span>
        <span slot="noOptions" class="no_results">{{ $t('no_results') }}</span>
    </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

import Vue from 'vue';
// register globally
Vue.component('multiselect', Multiselect)

export default {
    name: 'custom-search-select',
    props: {
        value: Number,
        options: {
            type: Array,
            required: true,
        },
        defaultId: {
            type: String,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        idFunc: Function,
        labelFunc: Function
    },
    data: function () {
        return {
            optionsSorted: this.sortedOptions(this.options)
        }
    },
    watch: {
        options: function (v) {
            this.optionsSorted = this.sortedOptions(v)
        }
    },
    methods: {
        valueChanged(v) {
            if (v) {
                this.$emit('input', this.idFunc(v))
            }
        },
        sortedOptions(v) {
            return [...v].sort((a, b) => {
                const aLabel = this.labelFunc(a)
                const bLabel = this.labelFunc(b)
                if (typeof aLabel === 'number' && typeof bLabel === 'number') {
                    return aLabel - bLabel
                } else {
                    return aLabel.localeCompare(bLabel)
                }
            })
        }
    }
};
</script>

<style>
.search-select.multiselect--disabled .multiselect__tags {
    cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/templates/part/ui/custom-search-select.vue